import { createContext, useContext } from 'react';

/** Configuración del ambiente: la entrega el contenedor en /config.json (no se compila). */
export interface Config {
  /** Origen del API Gateway (https://api-dev.siniestrados.com.mx). */
  api: string;
  /** Emisor de Keycloak: URL pública del realm del ambiente. */
  emisor: string;
  clienteId: string;
  ambiente: string;
  /** Versión desplegada (`v0.20.2`, `develop-…`); vacía en el entorno local. */
  version: string;
}

export async function cargarConfig(): Promise<Config> {
  const r = await fetch('/config.json', { cache: 'no-store' });
  if (!r.ok) throw new Error(`No se pudo leer la configuración (${r.status})`);
  const c = (await r.json()) as Partial<Config>;
  if (!c.api || !c.emisor || !c.clienteId) throw new Error('Configuración incompleta');
  return {
    api: c.api.replace(/\/$/, ''),
    emisor: c.emisor,
    clienteId: c.clienteId,
    ambiente: c.ambiente ?? '',
    version: c.version ?? '',
  };
}

/** La configuración del ambiente en cualquier pantalla (emisor y API para guías y enlaces). */
export const ContextoConfig = createContext<Config | null>(null);
export function useConfig(): Config {
  const c = useContext(ContextoConfig);
  if (!c) throw new Error('Falta ContextoConfig');
  return c;
}
